module.exports = __webpack_public_path__ + "static/media/smile-people.b77f4ac7.jpg";